import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { NavLink, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import { ACCESS_TOKEN_KEY, removeCookie } from '@src/services/storage/cookies';
import { Button } from '@mui/material';

const PAGE_LIST = [
  { name: '예약 신청', link: '/schedule' },
  { name: '신청 목록', link: '/schedule/request' },
  { name: '예약 대기', link: '/booking' },
  { name: '캘린터', link: '/schedule/club' },
  // { name: '신청 목록', link: '/schedule/request' },
];
const ADMIN_PAGE_LIST = [
  { name: '장소 추가', link: '/admin/add-booking-place' },
  { name: '장소 목록', link: '/admin/booking-place-list' },
  { name: '신청 목록', link: '/admin/schedule/request' },
  { name: '캘린더', link: '/admin/schedule' },
  // { name: '신청 목록', link: '/schedule/request' },
];
const settings = ['Logout'];

const AppBarColor = styled(AppBar)`
  background-color: #222222 !important;
`;

const Link = styled.a`
  padding: 0 20px;
  &:hover {
    cursor: pointer;
  }
`;

const MenuLink = styled(NavLink)`
  padding: 0 20px;
`;

type PropTypes = {
  isAdmin: boolean;
};

function AppHeader({ isAdmin }: PropTypes) {
  const navitate = useNavigate();
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const [anchorElAdmin, setAnchorElAdmin] = React.useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenNavAdmin = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElAdmin(event.currentTarget);
  };
  const handleCloseNavAdmin = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElAdmin(null);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleSignOut = () => {
    removeCookie(ACCESS_TOKEN_KEY);
    navitate('/signin');
  };
  const handleCloseUserMenu = (setting?: (typeof settings)[number]) => {
    setAnchorElUser(null);
    switch (setting) {
      case 'Logout':
        handleSignOut();
        break;
    }
  };

  return (
    <AppBarColor position="static" color="warning">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <InsertEmoticonIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {PAGE_LIST.map(page => (
                <MenuItem key={page.link} onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">{page.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <InsertEmoticonIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {PAGE_LIST.map(page => (
              <MenuLink key={page.link} to={page.link}>
                {page.name}
              </MenuLink>
            ))}
          </Box>
          {isAdmin ? (
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' } }}>
              <Button onClick={handleOpenNavAdmin}>Admin</Button>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElAdmin}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElAdmin)}
                onClose={handleCloseNavAdmin}
              >
                {ADMIN_PAGE_LIST.map(page => (
                  <MenuLink key={page.link} onClick={handleCloseNavAdmin} to={page.link}>
                    <Typography textAlign="center">{page.name}</Typography>
                  </MenuLink>
                ))}
              </Menu>
            </Box>
          ) : (
            <></>
          )}
          <Box sx={{ flexGrow: 0 }}>
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
            </IconButton>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={() => handleCloseUserMenu()}
            >
              {settings.map(setting => (
                <MenuItem key={setting} onClick={() => handleCloseUserMenu(setting)}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBarColor>
  );
}
export default AppHeader;
